import { Link } from "react-router-dom";
import { COMPANY, FAQS } from "../constants/site";
import { Seo } from "../components/site/Seo";
import { Reveal, SectionHead } from "../components/site/Shared";
import { Icon } from "../components/site/Icon";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";

export default function Help() {
  return (
    <>
      <Seo
        title="Help Centre & FAQs"
        description="Answers about HomeAligns: household and asset management, multiple properties, warranty tracking, family sharing, AI scanning, service bookings, membership plans, vendor registration, privacy and account deletion."
        path="/help"
      />
      <section className="container-site max-w-4xl py-20 lg:py-24">
        <SectionHead
          level={1}
          eyebrow="Help Centre"
          title="How can we help?"
          sub="Answers to the questions we hear most. Can't find yours? Email us — a human replies."
        />
        <Reveal>
          <Accordion type="single" collapsible className="w-full" data-testid="help-faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`faq-${i}`} className="border-teal-deep/10">
                <AccordionTrigger
                  data-testid={`help-faq-trigger-${i}`}
                  className="text-left text-base font-bold text-ink hover:text-teal-deep hover:no-underline"
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm leading-relaxed text-ink/65">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal className="mt-14 grid gap-6 md:grid-cols-2">
          <div className="card-site p-8">
            <span className="icon-tile"><Icon name="Mail" className="h-5 w-5" /></span>
            <h2 className="mt-5 text-lg font-bold text-ink">Talk to support</h2>
            <p className="mt-2 text-sm leading-relaxed text-ink/60">
              Email us and we'll get back to you. Privacy requests are answered within 30 days.
            </p>
            <a href={`mailto:${COMPANY.supportEmail}`} data-testid="help-email-btn" className="btn-primary mt-6">
              {COMPANY.supportEmail}
            </a>
          </div>
          <div className="card-site p-8">
            <span className="icon-tile"><Icon name="FileText" className="h-5 w-5" /></span>
            <h2 className="mt-5 text-lg font-bold text-ink">Policies & your data</h2>
            <p className="mt-2 text-sm leading-relaxed text-ink/60">
              Read our policies, or learn how to export and delete your data.
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/privacy-policy" data-testid="help-privacy-link" className="btn-secondary !px-5 !py-2.5 !text-xs">Privacy Policy</Link>
              <Link to="/account-deletion" data-testid="help-deletion-link" className="btn-secondary !px-5 !py-2.5 !text-xs">Account & Data Requests</Link>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
